import { render, staticRenderFns } from "./bill-survey.vue?vue&type=template&id=29673d48&scoped=true"
import script from "./bill-survey.vue?vue&type=script&lang=ts"
export * from "./bill-survey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29673d48",
  null
  
)

export default component.exports